<!-- 职称服务-申报条件 -->
<template>
  <div>
    <!-- 专业技术资格认定 -->
    <template v-if="type===APPLY_TYPE.ZYJSZGRD">
      <div class="p-40">申报考核认定专业技术资格必须具备下述各级别档次相应的学历（学位）、资历等条件:</div>
      <div class="list-title">选择认定级别</div>
      <van-radio-group
        v-model="formData.level"
        class="p-40 flex"
        direction="horizontal"
        @change="saveCache()"
      >
        <van-radio
          v-for="item in levelData"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >{{ item.label }}</van-radio>
      </van-radio-group>
      <div class="list-title">选择您的学历&资历（工作年限）</div>
      <van-radio-group v-model="formData.workingSeniority" class="p-40" @change="saveCache()">
        <!-- 员级 -->
        <template v-if="formData.level===CONDITION_LEVEL.LEVEL_1">
          <van-radio class="mb-40" :name="10001">全日制中专毕业后，从事本专业或相近专业技术工作1年以上</van-radio>
          <!-- <van-radio class="mb-40" :name="10002">全日制中职毕业后，从事本专业或相近专业技术工作1年以上</van-radio> -->
          <van-radio class="mb-40" :name="10003">全日制技工院校中级技工班毕业后，从事本专业或相近专业技术工作1年以上</van-radio>
        </template>
        <!-- 助理级 -->
        <template v-if="formData.level===CONDITION_LEVEL.LEVEL_2">
          <van-radio class="mb-40" :name="20001">全日制技工院校高级工班毕业后，从事本专业或相近专业技术工作3年以上</van-radio>
          <van-radio class="mb-40" :name="20002">全日制大专毕业后，从事本专业或相近专业技术工作3年以上</van-radio>
          <van-radio class="mb-40" :name="20003">全日制技工院校预备技师（技师）班毕业后，从事本专业或相近专业技术工作1年以上</van-radio>
          <van-radio class="mb-40" :name="20004">全日制本科毕业后，从事本专业或相近专业技术工作1年以上</van-radio>
          <van-radio class="mb-40" :name="20005">全日制获双学士学位后，从事本专业或相近专业技术工作1年以上</van-radio>
          <van-radio class="mb-40" :name="20006">全日制硕士研究生毕业后，从事本专业或相近专业技术工作</van-radio>
          <van-radio class="mb-40" :name="20007">全日制研究生班毕业后，从事本专业或相近专业技术工作1年以上</van-radio>
        </template>
        <!-- 中级 -->
        <template v-if="formData.level===CONDITION_LEVEL.LEVEL_3">
          <van-radio class="mb-40" :name="30001">全日制硕士研究生毕业，从事本专业或相近专业技术工作3年以上</van-radio>
          <van-radio class="mb-40" :name="30002">全日制博士研究生毕业，从事本专业或相近专业技术工作</van-radio>
        </template>
      </van-radio-group>
    </template>

    <!-- 专业技术资格评审 -->
    <template v-if="type===APPLY_TYPE.ZYJSZGPS">
      <div class="list-title">选择评审系列</div>
      <van-radio-group
        v-model="formData.series"
        class="p-40 flex"
        direction="horizontal"
        @change="saveCache()"
      >
        <van-radio
          v-for="item in SERIES_SELECTS"
          :key="item.value"
          class="flex1"
          :name="item.value"
        >{{ item.label }}</van-radio>
      </van-radio-group>
      <div class="list-title">选择评审级别</div>
      <sh-picker-field
        v-model="formData.level"
        title="评审级别"
        :text-data="CONDITION_LEVEL_TEXT"
        :columns="levelData.map((item)=>item.label)"
        @input="saveCache()"
      ></sh-picker-field>

      <div v-if="formData.series!==SERIES.OTHERS" class="list-title">选择您的学历&资历（工作年限）</div>
      <van-radio-group v-model="formData.workingSeniority" class="p-40" @change="saveCache()">
        <!-- 工程系列 -->
        <template v-if="formData.series === SERIES.PROJECT">
          <!-- 员级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_1">
            <van-radio class="mb-40" :name="10001">大学专科、中专毕业，见习1年期满</van-radio>
            <van-radio class="mb-40" :name="10002">本科学历或学士学位，无资历要求</van-radio>
          </template>
          <!-- 助理级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_2">
            <van-radio class="mb-40" :name="20001">中专毕业，取得技术员专业技术资格后，从事专业技术工作满4年</van-radio>
            <van-radio class="mb-40" :name="20002">大专毕业，取得技术员专业技术资格后，从事专业技术工作满2年</van-radio>
            <van-radio class="mb-40" :name="20003">本科学历或学士学位，见习1年期满</van-radio>
            <van-radio class="mb-40" :name="20004">硕士学位或第二学士学位，无资历要求</van-radio>
          </template>
          <!-- 中级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_3">
            <van-radio class="mb-40" :name="30004">大专毕业，取得助理工程师专业技术资格后，从事专业技术工作满4年</van-radio>
            <van-radio class="mb-40" :name="30003">本科或学士学位，取得助理工程师专业技术资格后，从事专业技术工作满4年</van-radio>
            <van-radio class="mb-40" :name="30002">硕士学位或第二学士学位，取得助理工程师专业技术资格后，从事专业技术工作满2年</van-radio>
            <van-radio class="mb-40" :name="30001">博士学位，无资历要求</van-radio>
          </template>
          <!-- 副高级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_4">
            <van-radio class="mb-40" :name="40002">本科及以上学历，取得中级专业技术资格后，从事专业技术工作满5年</van-radio>
            <van-radio class="mb-40" :name="40001">博士学位，取得中级专业技术资格后，从事专业技术工作满2年</van-radio>
          </template>
          <!-- 正高级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_5">
            <van-radio class="mb-40" :name="50001">本科及以上学历，取得副高级工程师专业技术资格后，从事专业技术工作满5年</van-radio>
          </template>
        </template>

        <!-- 档案系列 -->
        <template v-if="formData.series === SERIES.FILE">
          <!-- 员级 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_1">
            <van-radio class="mb-40" :name="60001">中专毕业后1年</van-radio>
          </template>
          <!-- 助馆 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_6">
            <van-radio class="mb-40" :name="70001">中专毕业后5年</van-radio>
            <van-radio class="mb-40" :name="70002">大专毕业后3年</van-radio>
            <van-radio class="mb-40" :name="70003">本科或研究生班或获双学士学位毕业后1年</van-radio>
          </template>
          <!-- 馆员 -->
          <template v-if="formData.level === CONDITION_LEVEL.LEVEL_7">
            <van-radio class="mb-40" :name="80009">中专毕业后8年（取得助馆后）</van-radio>
            <van-radio class="mb-40" :name="80010">中专毕业后15年（未取得助馆资格）</van-radio>
            <van-radio class="mb-40" :name="80007">大专毕业后5年（取得助馆后）</van-radio>
            <van-radio class="mb-40" :name="80008">大专毕业后10年（未取得助馆资格）</van-radio>
            <van-radio class="mb-40" :name="80005">本科毕业或获学士学位后3年（取得助馆后）</van-radio>
            <van-radio class="mb-40" :name="80006">本科毕业或获学士学位后5年（未取得助馆资格）</van-radio>
            <van-radio class="mb-40" :name="80003">研究生班毕业或获双学士学位后2年（取得助馆后）</van-radio>
            <van-radio class="mb-40" :name="80004">研究生班毕业或获双学士学位后4年（未取得助馆资格）</van-radio>
            <van-radio class="mb-40" :name="80002">获硕士学位后2年</van-radio>
            <van-radio class="mb-40" :name="80001">获硕士学位后3年</van-radio>
          </template>
        </template>
      </van-radio-group>
    </template>

    <CFooter></CFooter>
    <div class="height-180"></div>
    <div class="fixed-bottom border-box p-40">
      <van-button block round type="info" @click="handleToNext">下一步</van-button>
    </div>
  </div>
</template>

<script>
import {
  APPLY_TYPE,
  CONDITION_LEVEL,
  CONDITION_LEVEL_TEXT,
  SERIES,
  SERIES_SELECTS,
  findEnumKey,
} from "@share/enum"
import CFooter from "@/components/CFooter.vue"
import { Toast } from "vant"
import shPickerField from "@/components/sh-picker-field.vue"

export default {
  name: "TitleServiceCondition",
  components: {
    CFooter,
    "sh-picker-field": shPickerField,
  },
  data: () => {
    return {
      APPLY_TYPE,
      CONDITION_LEVEL,
      CONDITION_LEVEL_TEXT,
      SERIES,
      SERIES_SELECTS,
      isLoaded: false,
      type: "",
      isShowLevel: false,
      levelData: null, // 等级数据
      formData: null,
    }
  },
  computed: {},
  watch: {
    "formData.level"() {
      if (this.isLoaded) {
        this.formData.workingSeniority = ""
      }
    },
    "formData.series"(val) {
      if (this.isLoaded) {
        this.formData.level = ""
        if (val === SERIES.PROJECT || val === SERIES.OTHERS) {
          this.levelData = [
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_1],
              value: CONDITION_LEVEL.LEVEL_1,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_2],
              value: CONDITION_LEVEL.LEVEL_2,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_3],
              value: CONDITION_LEVEL.LEVEL_3,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_4],
              value: CONDITION_LEVEL.LEVEL_4,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_5],
              value: CONDITION_LEVEL.LEVEL_5,
            },
          ]
        } else if (val === SERIES.FILE) {
          this.levelData = [
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_1],
              value: CONDITION_LEVEL.LEVEL_1,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_6],
              value: CONDITION_LEVEL.LEVEL_6,
            },
            {
              label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_7],
              value: CONDITION_LEVEL.LEVEL_7,
            },
          ]
        }
      }
    },
  },
  created() {
    this.type = Number(this.$route.params.type)
    const formData = {
      level: CONDITION_LEVEL.LEVEL_1, // 认定级别
      workingSeniority: 1001, // 学历&资历（工作年限）
    }
    let levelData = [
      {
        label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_1],
        value: CONDITION_LEVEL.LEVEL_1,
      },
      {
        label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_2],
        value: CONDITION_LEVEL.LEVEL_2,
      },
      {
        label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_3],
        value: CONDITION_LEVEL.LEVEL_3,
      },
    ]
    if (this.type === APPLY_TYPE.ZYJSZGPS) {
      formData.series = SERIES.PROJECT
      levelData = levelData.concat([
        {
          label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_4],
          value: CONDITION_LEVEL.LEVEL_4,
        },
        {
          label: CONDITION_LEVEL_TEXT[CONDITION_LEVEL.LEVEL_5],
          value: CONDITION_LEVEL.LEVEL_5,
        },
      ])
    }
    this.levelData = levelData
    const formDataCache = JSON.parse(
      sessionStorage.getItem("TITLESERVICE_STEP_1") || null
    )
    if (!formDataCache) {
      this.formData = formData
    } else {
      this.setFormParams(formDataCache)
    }
    this.$nextTick(() => {
      this.isLoaded = true
    })
    // sessionStorage.removeItem("TITLESERVICE_STEP_1")
  },
  mounted() {},
  methods: {
    saveCache() {
      sessionStorage.setItem(
        "TITLESERVICE_STEP_1",
        JSON.stringify(this.getFormParams(this.formData))
      )
    },
    handleToNext() {
      if (!this.checkSubmit()) return
      this.saveCache()
      this.$router.push({
        path: `/apply/titleService/baseInfo/${this.type}`,
      })
    },
    handleLevelPickerConfirm(e) {
      this.formData.level = Number(findEnumKey(CONDITION_LEVEL_TEXT, e))
      this.isShowLevel = false
    },
    /** 设置表单参数 */
    setFormParams(data) {
      this.formData = {}
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        this.formData = {
          ...this.formData,
          level: data.a10001,
          workingSeniority: data.a10002,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        this.formData = {
          ...this.formData,
          series: data.a20001,
          level: data.a20002,
          workingSeniority: data.a20003,
        }
      }
    },
    /** 获取表单参数 */
    getFormParams() {
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        return {
          a10001: this.formData.level,
          a10002: this.formData.workingSeniority,
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        return {
          a20001: this.formData.series,
          a20002: this.formData.level,
          a20003: this.formData.workingSeniority,
        }
      }
    },
    /** 校验提交 */
    checkSubmit() {
      if (this.type === APPLY_TYPE.ZYJSZGRD) {
        if (!this.formData.level) {
          Toast("请选择认定级别")
          return false
        }
        if (!this.formData.workingSeniority) {
          Toast("请选择您的学历&资历（工作年限）")
          return false
        }
      } else if (this.type === APPLY_TYPE.ZYJSZGPS) {
        if (!this.formData.series) {
          Toast("请选择评审系列")
          return false
        }
        if (!this.formData.level) {
          Toast("请选择评审级别")
          return false
        }
        if (this.formData.series !== SERIES.OTHERS) {
          if (!this.formData.workingSeniority) {
            Toast("请选择您的学历&资历（工作年限）")
            return false
          }
        }
      }
      return true
    },
  },
}
</script>

<style lang="scss" scope>
@import "~@/assets/style/app";
</style>
